if (typeof define === "function" && define.amd) {
    define('Controls/ReCaptcha',[], function () {
        function ReCaptcha(container) {
        	this.container = $(container);
        	this.gRecaptcha = this.container.find(".g-recaptcha");
            this.siteKey = this.gRecaptcha.attr('data-sitekey');
			      this.gRecaptchaVer = this.gRecaptcha.attr('data-recaptcha-version');
			      this.saltValue = this.container.closest("[data-salt-form]").attr("data-salt-form");
            if(this.siteKey != '') {
        		this.init();
            }
        }

        ReCaptcha.prototype.init = function () {
            var o = this;
            if(o.gRecaptcha.length > 0) o.gRecaptcha = o.gRecaptcha[0];

			if (typeof o.gRecaptchaVer !== typeof undefined && o.gRecaptchaVer !== false && o.gRecaptchaVer == "v3") {
			     grecaptcha.ready(function() {
					return grecaptcha.execute(o.siteKey, {action: o.saltValue}).then(function(token) {
					   return $("<input>").attr({
							name: "token",
							id: "token",
							type: "hidden",
							value: token
						}).appendTo(o.container);

					   onSubmitAfterCaptchaValidate();
					});
				});
			}else{
			  var widgetIdRecaptcha = grecaptcha.render(o.gRecaptcha,{'sitekey' : o.siteKey, 'callback' : onSubmitAfterCaptchaValidate, 'size' : 'invisible'});

			  o.container.data('recaptcha-widget-id',widgetIdRecaptcha);

			  grecaptcha.reset(widgetIdRecaptcha);
			  grecaptcha.execute(widgetIdRecaptcha);
			}

            o.container.parents('form').addClass('validate-recaptcha');
        };

		window.onSubmitAfterCaptchaValidate = function () {
			var FormCheck = $(document).find(".validate-recaptcha");
			$(document).find(".validate-recaptcha").removeClass('validate-recaptcha');

			if(FormCheck.length > 0) {

				if (FormCheck.hasClass('send-form')) {
					var stepsBox =  $('.modal-steps');
					var preleadMess = $('.prelead-number-mess');
					var itemForm = FormCheck;
					itemForm.find('input[type="submit"]').attr('disabled', 'disabled');
					var clockBox = stepsBox.find('.active-step').find('.clock');
					clockBox.html('<div class="loader loader17 loader-easy float-right"></div>');
					var phone = itemForm.find('.field-phone').val();
					var marker = itemForm.find('.field-marker').val();
					var fantome = itemForm.find('.field-fantome').val();
					var recaptcha = itemForm.find('[name="g-recaptcha-response"]').val();

					$.ajax({
						type: "POST",
						dataType: 'json',
						data: {
							AJAX: 'callback.popup',
							phone: phone,
							fantome: fantome,
							recaptcha: recaptcha,
							COMPONENT_MARKER: marker
						},
						beforeSend: function () {
							require(['flipclock']);
						},
						url: document.location.href,
						success: function (data) {
							if (data.result == 1) {
								clockBox.empty();
								if (data.id > 0) {
									preleadMess.show();
									preleadMess.find('#prelead-number').html(data.id);
									preleadMess.find('#prelead-number-text').html(data.text);
								}
								var successRow = stepsBox.find('.success-row');
								var active = stepsBox.find('.active-step');

								active.removeClass('active-step');
								successRow.addClass('active-step');
								$('#ouibounce-modal').trigger('modal.refresh');

								var successClockBox = stepsBox.find('.active-step').find('.clock');
								var digit = 5 * 60;
								require(['flipclock'], function () {
									var clock = successClockBox.FlipClock(digit, {
										language: 'russian',
										countdown: true,
										clockFace: 'MinuteCounter'
									});
									itemForm.data('clock', clock);
								});
								window.track([l('TRACK_1'), l('TRACK_PHONE'), l('SEND_PHONE') + $('#ouibounce-modal').data('webformId'), 1]);
								console.log(l('SEND_PHONE') + $('#ouibounce-modal').data('webformId'));
								var trackStepPath = location.pathname + location.search;
								trackStepPath += (location.search.length > 0) ? '&' : '?';
								trackStepPath += 'formresult=addok&WEB_FORM_ID=' + $('#ouibounce-modal').data('webformId');
								window.trackStep(trackStepPath);
								if (typeof window.SeoTrackHelper.sendGoal === "function") window.SeoTrackHelper.sendGoal("send","callHunter");
							} else {
								clockBox.html(data.error);
							}
						},
						error: function () {
							clockBox.html( l('SEND_ERROR'));
						},
						complete: function () {
							itemForm.find('input[type="submit"]').removeAttr('disabled')
						}
					});
					return false;
				}
				else{
					FormCheck[0].submit();
				}


			}
		};



		return ReCaptcha;
	});
}
;
